<div
  class="overlay"
  [class.visible]="uiService.isOverlayOpen$ | async"
  [class.block-horizontal-scrolling]="blockHorizontalScrolling()"
>
  <div class="overlay-container">
    <div class="overlay-header flex flex-row justify-between items-center">
      <div
        class="flex flex-row lt-md:flex-col flex-wrap gap-[12px] justify-start items-center lt-md:items-start"
      >
        <h1 [class.no-margin]="activeOverlay === featuresDetailsOverlayTypeEnum.Gateway">
          {{ header }}
          <mat-icon
            *ngIf="toolTipInfo"
            [matTooltip]="toolTipInfo"
            matTooltipClass="multiline-tooltip"
            >info</mat-icon
          >
        </h1>
        <ng-content select="[header]"></ng-content>
      </div>
      <div class="flex flex-row items-center gap-[12px]">
        <ng-content select="[header-right]"></ng-content>
        <button
          data-at-close-overlay-btn
          mat-stroked-button
          (click)="close()"
          class="close-btn-overlay lt-md:!hidden"
          gtm="onClose"
          gtmAction="Installation details overlay"
          gtmCategory="installationDetails"
        >
          <span>{{ '+INSTALLATIONS.INSTALLATION.OVERLAY.CLOSE_BUTTON' | translate }}</span>
          <mat-icon iconPositionEnd>close</mat-icon>
        </button>
        <button
          mat-icon-button
          (click)="close()"
          class="close-btn-small lt-md:!flex !hidden"
          gtm="onClose"
          gtmAction="Installation details overlay"
          gtmCategory="installationDetails"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <ng-content select="[body]"></ng-content>
  </div>
</div>
